import { fromAsync } from "../../async/static/fromAsync.js";
export const groupJoinAsync = (outer, inner, outerKeySelector, innerKeySelector, resultSelector, comparer) => {
    const generator = comparer ?
        groupJoinWithComparer(outer, inner, outerKeySelector, innerKeySelector, resultSelector, comparer) :
        groupJoinSimple(outer, inner, outerKeySelector, innerKeySelector, resultSelector);
    return fromAsync(generator);
};
const groupJoinWithComparer = (outer, inner, outerKeySelector, innerKeySelector, resultSelector, comparer) => {
    return async function* () {
        const innerKeyMap = [];
        for (const innerValue of inner) {
            const key = await innerKeySelector(innerValue);
            const record = innerKeyMap.find(x => comparer(x.key, key));
            if (record) {
                record.values.push(innerValue);
            }
            else {
                innerKeyMap.push({ key, values: [innerValue] });
            }
        }
        for (const outerValue of outer) {
            const key = await outerKeySelector(outerValue);
            const innerRecord = innerKeyMap.find(x => comparer(x.key, key)) ?? { key, values: [] };
            yield resultSelector(outerValue, innerRecord.values);
        }
    };
};
const groupJoinSimple = (outer, inner, outerKeySelector, innerKeySelector, resultSelector) => {
    return async function* () {
        const innerKeyMap = new Map();
        for (const innerValue of inner) {
            const key = await innerKeySelector(innerValue);
            const values = innerKeyMap.get(key);
            if (values) {
                values.push(innerValue);
            }
            else {
                innerKeyMap.set(key, [innerValue]);
            }
        }
        for (const outerValue of outer) {
            const key = await outerKeySelector(outerValue);
            const values = innerKeyMap.get(key) ?? [];
            yield resultSelector(outerValue, values);
        }
    };
};
